import React from 'react'
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";

const SocialButtons = () => {
    return (
        <div className="sticky-left-container">
            <ul className="sticky-left">
                <li>
                    <a href={"https://www.instagram.com/altunotolastik/"} target='_blank' rel="noreferrer">
                        <FaInstagram className="instagram" />
                        <p>Instagram</p>
                    </a>
                </li>
                <li>
                    <a href={"https://www.facebook.com/profile.php?id=100032739833072"} target='_blank' rel="noreferrer">
                        <FaFacebookF className="facebook" />
                        <p>Facebook</p>
                    </a>
                </li>
                <li>
                    <a href={"https://wa.me/+905441205454"} target='_blank' rel="noreferrer">
                        <FaWhatsapp className="whatsapp" />
                        <p>WhatsApp</p>
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default SocialButtons